import { get, getDownload, post, put, del } from '../utils/api';
import { addQueryData } from '../utils/query-helpers';

export default class RentForecastService {
  async createRentForecast(organizationId, propertyId, options) {
    return await post(
      `/${organizationId}/${propertyId}/rent-forecast`,
      options,
    );
  }

  async getAllRentForecast(organizationId, propertyId) {
    return await get(`/${organizationId}/${propertyId}/rent-forecast`);
  }

  async updateRentForecast(
    organizationId,
    propertyId,
    id,
    body,
    updateSnapshotData: boolean = false,
  ) {
    return await put(
      addQueryData(
        `/${organizationId}/${propertyId}/rent-forecast/${id}`,
        updateSnapshotData ? { updateSnapshotData } : {},
      ),
      body,
    );
  }

  async downloadReport(
    organizationId: string,
    propertyId: string,
    rentForecastId: string,
    reportId: string,
    fileType: 'pdf' | 'xml' = 'pdf',
  ): Promise<any> {
    const path = [
      organizationId,
      propertyId,
      'rd-budget-form',
      rentForecastId,
      'download-report',
      reportId,
    ].join('/');

    return getDownload(`/${path}?fileType=${fileType}`, `report.${fileType}`);
  }

  async deleteRentForecast(
    organizationId: string,
    propertyId: string,
    rentForecastId: string,
  ): Promise<Object> {
    return del(
      `/${organizationId}/${propertyId}/rent-forecast/${rentForecastId}`,
      null,
      {
        fullError: true,
      },
    );
  }
}
